{
  "name": "@wix/create-new",
  "description": "General entry point for creating Wix projects",
  "version": "0.0.96",
  "bin": "bin/index.cjs",
  "devDependencies": {
    "@commander-js/extra-typings": "^13.0.0",
    "@vercel/detect-agent": "^1.2.1",
    "@wix/app-command": "workspace:*",
    "@wix/cli-auth": "workspace:*",
    "@wix/cli-error-reporting": "workspace:*",
    "@wix/cli-panorama": "workspace:*",
    "@wix/cli-test-overrides": "workspace:*",
    "@wix/create-app-definitions": "workspace:*",
    "@wix/headless-command": "workspace:*",
    "@wix/package-manager": "workspace:*",
    "@wix/tsup-configs": "workspace:*"
  },
  "engines": {
    "node": ">= 20.11.0"
  },
  "files": [
    "bin",
    "build",
    "templates"
  ],
  "publishConfig": {
    "registry": "https://registry.npmjs.org/",
    "access": "public",
    "versionBumpStrategy": "manual",
    "logLevel": "verbose"
  },
  "scripts": {
    "build": "run -T tsup",
    "build:watch": "run -T build:watch --filter='@wix/create-new'",
    "dev:npm": "npx $INIT_CWD",
    "dev:yarn": "yarn create @wix/create-new@portal:$INIT_CWD",
    "test": "yarn workspace @wix/create-new-spec run test",
    "test:watch": "yarn workspace @wix/create-new-spec run test:watch",
    "typecheck": "run -T tsc --noEmit"
  },
  "type": "module",
  "wix": {
    "artifact": {
      "groupId": "com.wixpress",
      "artifactId": "wix-cli-create-new"
    },
    "validations": {
      "postBuild": [
        "typecheck"
      ]
    }
  }
}
